import React from 'react';

type CollapsibleSectionHeaderProps = {
    title: string;
    isExpanded: boolean;
    onToggle: () => void;
}

export const CollapsibleSectionHeader: React.FC<CollapsibleSectionHeaderProps> = ({
    title,
    isExpanded,
    onToggle
}) => {
    return (
        <div
            className="tw-px-4 tw-py-3 tw-flex tw-justify-between tw-items-center tw-cursor-pointer"
            onClick={onToggle}
        >
            <h3 className="tw-text-[#6D788C] tw-text-sm tw-font-semibold">{title}</h3>
            <svg
                className={`tw-w-4 tw-h-4 tw-transition-transform ${isExpanded ? 'tw-rotate-180' : ''}`}
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
        </div>
    );
};
